module.exports = __webpack_public_path__ + "img/link-banner-jp.0a772d84.png";